import React, { useEffect, useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import './CaseDetailsTool.scss';
import CurrencyFormat from '../../Common/formatters/CurrencyFormat';
import { format } from 'date-fns';
import { GetFormattedNumber } from '../../Helpers/Formatters';
import { ConvertUTCToLocalDate } from '../../Helpers/Formatters/UTCToLocalDate';
import Age from '../../Helpers/Dates/Age';

export default function Ticket(props) {

    const [healthClass, setHealthClass] = useState('');

    useEffect(() => {
        const healthClass = props.selectedCaseDetails.HealthClassName;
        if (healthClass === 'PP') {
            setHealthClass('Exceptionally');
        } else if (healthClass === 'P') {
            setHealthClass('Very Health');
        } else if (healthClass === 'RP') {
            setHealthClass('Above Average Health');
        } else if (healthClass === 'R') {
            setHealthClass('Very Health');
        } else if (healthClass === 'RR') {
            setHealthClass('Below Average Health');
        }

    }, [])

    const details = props.selectedCaseDetails;
   console.log(props.selectedCaseDetails);
    return (
        <Container>
            {details !== null &&
                <React.Fragment>
                    <div>
                        <div id="qoute-info-header" className="quote-title">Quote Information</div>
                        <Row>
                            <Col md={4}>
                              <p id="quote-reference-number-label" className="stat-title">Reference Number</p>
                              <p id="quote-reference-number" className="stat-text">{props.selectedCaseDetails.referenceID}</p>
                            </Col>
                            <Col md={4}>
                              <p id="quote-ticket-number-label" className="stat-title">ITS Ticket Number</p>
                              <p id="quote-ticket-number" className="stat-text">{props.selectedCaseDetails.partnerReferenceID || 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="quote-submission-date-label" className="stat-title">Quote Submission Date</p>
                              <p id="quote-submission-date" className="stat-text">{props.selectedCaseDetails.createdDate ? ConvertUTCToLocalDate(props.selectedCaseDetails.createdDate) : 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="quote-status-label" className="stat-title">Status</p>
                              <p id="quote-status" className="stat-text">{props.selectedCaseDetails.status || 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="quote-reg60-label" className="stat-title">Reg 60</p>
                              <p id="quote-reg60" className="stat-text">{props.selectedCaseDetails.isReg60 ? 'Yes' : 'No'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="quote-replacement-label" className="stat-title">Replacement</p>
                              <p id="quote-replacement" className="stat-text">{props.selectedCaseDetails.isReplacement ? 'Yes' : 'No'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="quote-esign-label" className="stat-title">ESign</p>
                              <p id="quote-esign" className="stat-text">{props.selectedCaseDetails.isESign ? 'Yes' : 'No'}</p>
                            </Col>
                        </Row>
                    </div>

                    <div>
                        <div id="policy-info-header" className="quote-title">Policy</div>
                        <Row>
                          <Col md={4}>
                            <p id="policy-carrier-label" className="stat-title">Carrier</p>
                            <p id="policy-carrier" className="stat-text">{props.selectedCaseDetails.carrier || 'N/A'}</p>
                          </Col>
                          <Col md={4}>
                            <p id="policy-plan-label" className="stat-title">Plan</p>
                            <p id="policy-plan" className="stat-text">{props.selectedCaseDetails.plan || 'N/A'}</p>
                          </Col>
                          <Col md={4}>
                            <p id="policy-health-class-label" className="stat-title">Health Class</p>
                            <p id="policy-health-class" className="stat-text">{props.selectedCaseDetails.healthClassName || 'N/A'}</p>
                          </Col>
                          <Col md={4}>
                            <p id="policy-coverage-label" className="stat-title">Coverage</p>
                            <p id="policy-coverage" className="stat-text"><CurrencyFormat number={props.selectedCaseDetails.faceAmount} whole /></p>
                          </Col>
                          <Col md={4}>
                            <p id="policy-modal-premium-label" className="stat-title">Modal Premium</p>
                            <p id="policy-modal-premium" className="stat-text"><CurrencyFormat number={props.selectedCaseDetails.premium} whole /></p>
                          </Col>
                          <Col md={4}>
                            <p id="policy-submit-date-label" className="stat-title">Submit Date</p>
                            <p id="policy-submit-date" className="stat-text">{props.selectedCaseDetails.submitDate ? ConvertUTCToLocalDate(props.selectedCaseDetails.submitDate) : 'N/A'}</p>
                          </Col>
                          <Col md={4}>
                            <p id="policy-number-label" className="stat-title">Policy Number</p>
                            <p id="policy-number" className="stat-text">{props.selectedCaseDetails.policyNumber ? props.selectedCaseDetails.policyNumber : 'N/A'}</p>
                          </Col>
                        </Row>
                    </div>

                    <div>
                        <div id="pi-info-header" className="quote-title">Proposed Insured</div>
                        <Row>
                            <Col md={4}>
                              <p id="pi-name-label" className="stat-title">Name</p>
                              <p id="pi-name" className="stat-text">{props.selectedCaseDetails.firstName}  {props.selectedCaseDetails.lastName}</p>
                            </Col>
                            <Col md={4}>
                              <p id="pi-city-label" className="stat-title">City</p>
                              <p id="pi-city" className="stat-text">{props.selectedCaseDetails.city || 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="pi-state-label" className="stat-title">State</p>
                              <p id="pi-state" className="stat-text">{props.selectedCaseDetails.state || 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="pi-zip-label" className="stat-title">Zip</p>
                              <p id="pi-zip" className="stat-text">{props.selectedCaseDetails.zip || 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="pi-email-label" className="stat-title">Email</p>
                              <p id="pi-email" className="stat-text">{props.selectedCaseDetails.email || 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="pi-tobacco-use-label" className="stat-title">Smoker</p>
                              <p id="pi-tobacco-use" className="stat-text">{props.selectedCaseDetails.tobaccoUse ? 'Yes' : 'No'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="pi-birthdate-label" className="stat-title">Birthdate</p>
                              <p id="pi-birthdate" className="stat-text">{props.selectedCaseDetails.birthDate ? format(new Date(props.selectedCaseDetails.birthDate), 'MM-dd-yyyy') : 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="pi-issue-age-label" className="stat-title">Issue Age</p>
                              <p id="pi-issue-age" className="stat-text">{props.selectedCaseDetails.issueAge ? props.selectedCaseDetails.issueAge : props.selectedCaseDetails.birthDate ? Math.floor(Age(props.selectedCaseDetails.birthDate)) : 'N/A'}</p>
                            </Col>
                          <Col md={4}>
                            <p id="pi-gender-label" className="stat-title">Gender</p>
                            <p id="pi-gender" className="stat-text">{props.selectedCaseDetails.gender || 'N/A'}</p>
                          </Col>
                          <Col md={4}>
                            <p id="pi-primary-phone-label" className="stat-title">Primary Phone</p>
                            <p id="pi-primary-phone" className="stat-text">{GetFormattedNumber(props.selectedCaseDetails.primaryPhone) || 'N/A'}</p>
                          </Col>
                        </Row>
                    </div>
                    {props.selectedCaseDetails.isSurvivorshipPolicyType &&
                      <div>
                <div id="si-info-header" className="quote-title">Second Proposed Insured</div>
                        <Row>
                            <Col md={4}>
                              <p id="spi-name-label" className="stat-title">Name</p>
                              <p id="spi-name" className="stat-text">{props.selectedCaseDetails.secondaryInsuredFirstName}  {props.selectedCaseDetails.secondaryInsuredLastName}</p>
                            </Col>
                            <Col md={4}>
                              <p id="spi-city-label" className="stat-title">City</p>
                              <p id="spi-city" className="stat-text">{props.selectedCaseDetails.secondaryInsuredCity || 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="spi-state-label" className="stat-title">State</p>
                              <p id="spi-state" className="stat-text">{props.selectedCaseDetails.secondaryInsuredAddressState || 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="spi-zip-label" className="stat-title">Zip</p>
                              <p id="spi-zip" className="stat-text">{props.selectedCaseDetails.secondaryInsuredZip || 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="spi-email-label" className="stat-title">Email</p>
                              <p id="spi-email" className="stat-text">{props.selectedCaseDetails.secondaryInsuredEmail || 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="spi-tobacco-use-label" className="stat-title">Smoker</p>
                              <p id="spi-tobacco-use" className="stat-text">{props.selectedCaseDetails.secondaryInsuredTobacco ? 'Yes' : 'No'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="spi-birthdate-label" className="stat-title">Birthdate</p>
                              <p id="spi-birthdate" className="stat-text">{props.selectedCaseDetails.secondaryInsuredBirthDate ? format(new Date(props.selectedCaseDetails.secondaryInsuredBirthDate), 'MM-dd-yyyy') : 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="spi-issue-age-label" className="stat-title">Issue Age</p>
                              <p id="spi-issue-age" className="stat-text">{props.selectedCaseDetails.secondaryInsuredBirthDate ? Math.floor(Age(props.selectedCaseDetails.secondaryInsuredBirthDate)) : 'N/A'}</p>
                            </Col>
                          <Col md={4}>
                            <p id="spi-gender-label" className="stat-title">Gender</p>
                            <p id="spi-gender" className="stat-text">{props.selectedCaseDetails.secondaryInsuredGender || 'N/A'}</p>
                          </Col>
                          <Col md={4}>
                            <p id="spi-primary-phone-label" className="stat-title">Primary Phone</p>
                            <p id="spi-primary-phone" className="stat-text">{GetFormattedNumber(props.selectedCaseDetails.secondaryInsuredPhone) || 'N/A'}</p>
                          </Col>
                        </Row>
                    </div>
                    }
                    {!props.selectedCaseDetails.piIsOwner &&
                      <div>
                        <div id="owner-info-header" className="quote-title">Owner Information</div>
                          <Row>
                            <Col md={4}>
                              <p id="owner-fname-label" className="stat-title">Owner First Name</p>
                              <p id="owner-fname" className="stat-text">{props.selectedCaseDetails.ownerFirstName || 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="owner-lname-label" className="stat-title">Owner Last Name</p>
                              <p id="owner-lname" className="stat-text">{props.selectedCaseDetails.ownerLastName || 'N/A'}</p>
                            </Col>
                            <Col md={4}>
                              <p id="owner-DOB-label" className="stat-title">Birthdate</p>
                              <p id="owner-DOB" className="stat-text">{props.selectedCaseDetails.ownerBirthDate ? format(new Date(props.selectedCaseDetails.ownerBirthDate), 'MM-dd-yyyy') : 'N/A'}</p>
                            </Col>
                          </Row>
                      </div>
                    }
                </React.Fragment>}
        </Container>
    )
}


// WEBPACK FOOTER //
// ./src/components/ActivityCenter/SubComponents/TicketTab.js